import React from "react";
import ReactDOM from "react-dom";
import { Bar, Header } from "./components";
import "./scss/app.scss";

class App extends React.Component {
  render() {
    return (
      <div>
        <Bar />
        <Header />
      </div>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("app"));
